/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable prettier/prettier */
/* eslint-disable operator-linebreak */

import { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { BsCheckSquare, BsPiggyBankFill } from 'react-icons/bs';
import moment from 'moment';
import DebitoDTO from '../../dtos/DebitoDTO';
import { SelecaoDebitosModeProps, useAnuidade } from '../../hooks/anuidade';
import { Container } from './styles';
import Utils from '../../utils';

export function Debito() {
  const history = useHistory();
  const {
    anuidade,
    validarDebito,
    selecaoDebitosMode,
    changeSelectedDebito,
    onClickPagamentoTotal,
    onClickPagamentoVencidos,
    onClickPagamentoDebitosSelecionados,
  } = useAnuidade();
  const [valorTotalDebitosSelecionados, setValorTotalDebitosSelecionados] =
    useState('');
  const [gerarBoletoSeparadamente, setGerarBoletoSeparadamente] =
    useState(false);

  function perguntarDesejaBoletosSeparados(): boolean {
    const {
      tipoDebito: { CodigoTipo },
    } = anuidade;
    if (
      CodigoTipo === 12 ||
      CodigoTipo === 22 ||
      CodigoTipo === 102 ||
      CodigoTipo === 112 ||
      CodigoTipo === 122 ||
      CodigoTipo === 132 ||
      CodigoTipo === 142 ||
      CodigoTipo === 152 ||
      CodigoTipo === 162 ||
      CodigoTipo === 402 ||
      CodigoTipo === 412 ||
      CodigoTipo === 422 ||
      CodigoTipo === 702 ||
      CodigoTipo === 901 ||
      CodigoTipo === 902
    ) {
      const { debitos } = selecaoDebitosMode;
      const debitosSelecionados = debitos.filter((debito) => debito.selected);
      if (debitosSelecionados.length >= 2) {
        return true;
      }
    }
    if (gerarBoletoSeparadamente) {
      setGerarBoletoSeparadamente(false);
    }

    return false;
  }

  function atualizarValorTotalDebitosSelecionados({
    debitos,
  }: SelecaoDebitosModeProps) {
    const { debitoResult } = anuidade;

    if (debitos && debitos.length > 0) {
      const debitosSelecionados = debitos.filter((debito) => debito.selected);
      let valorTotal = debitosSelecionados.reduce(
        (result, d) => result + d.valor_total_deb,
        0,
      );

      const valorCashback = debitoResult ? debitoResult.ValorCashback : 0;
      const temCashback = valorCashback > 0;
      if (temCashback) {
        valorTotal -= valorCashback;
        if (valorTotal < 0) {
          valorTotal = 0;
        }
      }
      const valorPlano = debitoResult ? debitoResult.ValorPlano : 0;
      const temPlano = valorPlano > 0;
      if (temPlano) {
        valorTotal -= valorPlano;
        if (valorTotal < 0) {
          valorTotal = 0;
        }
      }

      let textoValorTotal = 'Valor total dos débitos selecionados';
      if (temCashback || temPlano) {
        textoValorTotal += '(';
        if (temCashback) {
          textoValorTotal += '-Cashback';
        }
        if (temPlano) {
          textoValorTotal += temCashback ? '-Plano de saúde' : 'Plano de saúde';
        }
        textoValorTotal += ')';
      }

      setValorTotalDebitosSelecionados(
        `${textoValorTotal}: R$ ${Utils.formatReal(valorTotal)}`,
      );
    }
  }

  useEffect(() => {
    atualizarValorTotalDebitosSelecionados(selecaoDebitosMode);
  }, [selecaoDebitosMode, atualizarValorTotalDebitosSelecionados]);

  useEffect(() => {
    if (
      !anuidade ||
      !anuidade.pagamentoAnuidadeInscrito ||
      !anuidade.tipoDebito
    ) {
      history.replace('/');
    } else {
      validarDebito();
    }
  }, []);

  function disabledBtnConfirmarSelecaoDebitos(): boolean {
    const { debitos } = selecaoDebitosMode;
    return !debitos.find((debito) => debito.selected);
  }

  function validateEnableSelectedDebito(debito: DebitoDTO): boolean {
    const { selectDebitosEnabled, debitos } = selecaoDebitosMode;
    if (!selectDebitosEnabled) {
      return false;
    }

    const debitosSelecionados = debitos.filter((d) => d.selected);
    if (debitosSelecionados.length === 0) {
      return true;
    }

    const validateCodLancDeb = debitosSelecionados.find((item) => {
      const result = item.cod_lanc_deb !== debito.cod_lanc_deb;
      return result;
    });
    if (validateCodLancDeb) {
      return false;
    }

    return true;
  }

  function getAnuidade(debito: DebitoDTO): string {
    if (debito.ano_fim_deb === debito.ano_inicio_deb) {
      return `${debito.ano_fim_deb}`;
    }
    return `${debito.ano_inicio_deb} / ${debito.ano_fim_deb}`;
  }
  function getDescricaoCota(debito: DebitoDTO): string {
    if (debito.total_cotas_deb === 0 && debito.cota_fim_deb === 0) {
      return '';
    }

    const totalCotas =
      debito.total_cotas_deb === 0 ? 'Int' : debito.total_cotas_deb;
    if (debito.cota_inicio_deb === debito.cota_fim_deb) {
      return `${debito.cota_fim_deb}/${totalCotas}`;
    }
    return `${debito.cota_inicio_deb}-${debito.cota_fim_deb}/${totalCotas}`;
  }

  function getDescricaoAvos(debito: DebitoDTO): string {
    if (debito.nro_avos_deb !== 0) {
      return `${debito.nro_avos_deb}`;
    }
    return '';
  }

  function getDataVencimento(debito: DebitoDTO): string {
    if (!debito.dta_venc_deb) {
      return '';
    }
    return moment(debito.dta_venc_deb, 'YYYYMMDD').format('DD/MM/YYYY');
  }

  if (!selecaoDebitosMode || !selecaoDebitosMode.debitos) {
    return null;
  }

  return (
    <Container>
      <div className="col-md-12">
        <div className="card mb-3">
          <div className="card-header text-white bg-danger">Débitos</div>
          <div className="card-body">
            <div className="base-buttons-actions-selecao-debitos-secondary">
              <div className="buttons-secondary">
                {selecaoDebitosMode.showBtnPagamentoTotal && (
                  <button
                    type="button"
                    onClick={() => {
                      onClickPagamentoTotal();
                    }}
                    className="btn btn-danger btn-pagamento-total-debitos"
                  >
                    <BsPiggyBankFill />
                    Pagar o total de débitos
                  </button>
                )}
              </div>

              <div className="info-valor-debitos-selecionados">
                {!disabledBtnConfirmarSelecaoDebitos() ? (
                  <p>{valorTotalDebitosSelecionados}</p>
                ) : null}
              </div>

              {selecaoDebitosMode.showBtnPagamentoVencidos && (
                <button
                  type="button"
                  onClick={() => {
                    onClickPagamentoVencidos();
                  }}
                  className="btn btn-danger pull-right"
                >
                  <i className="glyphicon glyphicon-hourglass" />
                  Pagamento somente os débitos vencidos
                </button>
              )}
              {selecaoDebitosMode.selectDebitosEnabled && (
                <button
                  type="button"
                  className={`btn pull-right btn-selecionar-mais-debitos ${
                    disabledBtnConfirmarSelecaoDebitos()
                      ? 'btn-outline-secondary'
                      : 'btn-danger'
                  }`}
                  disabled={disabledBtnConfirmarSelecaoDebitos()}
                  onClick={() => {
                    onClickPagamentoDebitosSelecionados(
                      gerarBoletoSeparadamente,
                    );
                  }}
                >
                  {!disabledBtnConfirmarSelecaoDebitos() && <BsCheckSquare />}
                  {`${
                    disabledBtnConfirmarSelecaoDebitos()
                      ? 'Selecione ao menos 1 débito para confirmar'
                      : 'Confirmar seleção de items'
                  }`}
                </button>
              )}
            </div>

            <div className="content-table">
              <table className="table">
                <thead>
                  <th className="text-center">Anuidade</th>
                  <th className="text-center">Cota</th>
                  <th className="text-center">Avos</th>
                  <th className="text-center">Valor</th>
                  <th className="text-center">Multa</th>
                  <th className="text-center">Permanência</th>
                  <th className="text-center">Vencimento</th>
                  <th className="text-center">Total</th>
                  <th> </th>
                </thead>
                <tbody>
                  {selecaoDebitosMode.debitos.map((debito) => (
                    <tr key={debito.id}>
                      <td className="text-center">{getAnuidade(debito)}</td>
                      <td className="text-center">
                        {getDescricaoCota(debito)}
                      </td>
                      <td className="text-center">
                        {getDescricaoAvos(debito)}
                      </td>
                      <td className="text-center">
                        {`R$ ${Utils.formatReal(debito.valor_anuid_deb)}`}
                      </td>
                      <td className="text-center">
                        {`R$ ${Utils.formatReal(debito.valor_multa_deb)}`}
                      </td>
                      <td className="text-center">
                        {`R$ ${Utils.formatReal(debito.valor_juros_deb)}`}
                      </td>
                      <td className="text-center">
                        {getDataVencimento(debito)}
                      </td>
                      <td className="text-center">
                        {`R$ ${Utils.formatReal(debito.valor_total_deb)}`}
                      </td>
                      <td className="text-center">
                        {validateEnableSelectedDebito(debito) && (
                          <input
                            type="checkbox"
                            checked={debito.selected}
                            onChange={() => {
                              changeSelectedDebito(debito);
                            }}
                          />
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            {perguntarDesejaBoletosSeparados() && (
              <div className="row">
                <div className="checkbox checkbox-gerar-boletos-separadamente">
                  <label>
                    <input
                      type="checkbox"
                      checked={gerarBoletoSeparadamente}
                      onChange={() => {
                        setGerarBoletoSeparadamente(!gerarBoletoSeparadamente);
                      }}
                    />
                    Deseja gerar os boletos separadamente?
                  </label>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </Container>
  );
}
